import { render, staticRenderFns } from "./category-picker.vue?vue&type=template&id=11e4a6ea&scoped=true&"
import script from "./category-picker.vue?vue&type=script&lang=js&"
export * from "./category-picker.vue?vue&type=script&lang=js&"
import style0 from "./category-picker.vue?vue&type=style&index=0&id=11e4a6ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e4a6ea",
  null
  
)

export default component.exports